import React from 'react';
import CallToAction from '../CallToAction/CallToAction';

const HeroCTA = ({ ctaConfig }) => {
    if (!ctaConfig?.hasCTA) return null;
    const titleText = ctaConfig.title?.text;
    const bodyText = ctaConfig.body?.text;
    const isButtonVisible = ctaConfig.button?.isVisible ?? true;
    const buttonLinkUrl = ctaConfig.button?.linkUrl;
    const buttonText = ctaConfig.button?.text;
    const isButtonOutlined = ctaConfig.button?.isOutlined ?? false;
    const buttonColor = ctaConfig.button?.color;
    const titleStyle = ctaConfig.title?.style;
    const bodyStyle = ctaConfig.body?.style;
    const buttonStyle = ctaConfig.button?.style;

    return (
        <CallToAction
            btnClass="anl_cta--keyvisual--btn-main"
            buttonColor="primary"
            buttonStyle={{
                ...(!isButtonOutlined && buttonColor && { backgroundColor: buttonColor }),
                ...(isButtonOutlined && { backgroundColor: 'transparent' }),
                ...(buttonColor && { borderColor: buttonColor }),
                ...(isButtonOutlined && buttonColor && !buttonStyle?.color && { color: buttonColor }),
            }}
            buttonStyleConfig={buttonStyle}
            buttonText={buttonText}
            buttonVisibility={isButtonVisible}
            copy={bodyText}
            copyStyleConfig={bodyStyle}
            headline={titleText}
            headlineStyleConfig={titleStyle}
            linkUrl={buttonLinkUrl}
            outline={isButtonOutlined}
        />
    );
};

export default HeroCTA;
